import * as React from 'react'
import BaseProvider, {
  ConfigProviderProps as BaseProps,
} from 'antd/lib/config-provider'

export interface ConfigProviderProps extends BaseProps {}

export const ConfigProvider = (props: ConfigProviderProps) => (
  <>
    <BaseProvider {...props} />
  </>
)
